import React, { Component } from 'react';
import {connect} from 'react-redux';
import { addDemographicsQuestion, emptyDemoQuestionResponse} from '../../actions/demographics';
import AddDemoCategoriesQues from '../../components/demographics/addDemoCatQuestion';

class AddDemographicsCategoriesQuestion extends Component {
  constructor(props){
    super(props)

    // this.queryString = window.location.href;

    // if (this.queryString !== "") {
    //   this.catID = this.queryString.split('&c:')[1];  //participant id 
    // }

    this.state={
        editCategoryPageData : "",
       // catID : this.catID
    };
    this.addQuestionDemographics = this.addQuestionDemographics.bind(this);
    this.emptyDemoQuestionResponse = this.emptyDemoQuestionResponse.bind(this);
  }

  componentDidMount(){
    if(this.props.location.state){
        const { editCategoryItemData } = this.props.location.state;

      if(editCategoryItemData){
          this.setState({
            editCategoryPageData : editCategoryItemData
        });
      }
    }else{
      this.props.history.push('/');
    }
  }

  addQuestionDemographics(data){
   this.props.dispatch(addDemographicsQuestion(data));
  }

  emptyDemoQuestionResponse(){
    this.props.dispatch(emptyDemoQuestionResponse());
  }
 
  
  render(){

    // if(this.state.catID){
    //     alert(this.state.catID);
    // }

    let showAddDemographicsCategoriesQuestionView = <AddDemoCategoriesQues
        editCategoryPageData = {this.state.editCategoryPageData}
        addQuestionDemographics = {this.addQuestionDemographics}

        demoGraphicsQuestionAddSuccess = {this.props.demoGraphicsQuestionAddSuccess}
        demoGraphicsQuestionSuccessmessage = {this.props.demoGraphicsQuestionSuccessmessage}
        demoGraphicsQuestionFailmessage = {this.props.demoGraphicsQuestionFailmessage}

        emptyDemoQuestionResponse = {this.emptyDemoQuestionResponse}
    />
      
    return (
        <div> 
             {showAddDemographicsCategoriesQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsQuestionAddSuccess     : state.demographics.demoGraphicsQuestionAddSuccess,
    demoGraphicsQuestionSuccessmessage : state.demographics.demoGraphicsQuestionSuccessmessage,
    demoGraphicsQuestionFailmessage    : state.demographics.demoGraphicsQuestionFailmessage,    
  }
}

export default connect(mapStateToProps)(AddDemographicsCategoriesQuestion);



// WEBPACK FOOTER //
// ./src/pages/demographics/addDemoCatQuestion.js